function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import moment from 'moment-timezone';
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import flattenDeep from 'lodash/fp/flattenDeep';
import { hasNextDaySuffix, stripNextDaySuffix } from './time-utils';
// Returns an empty string if can't produce an ISO string - may not be what you want!!
export var toISOString = function(date) {
    return date && typeof date.toISOString === 'function' ? date.toISOString() : '';
};
export var convertDate = function(time, timezone) {
    var date = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, daysOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, hoursOffset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, minutesOffset = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    if (time === 'Immediately') {
        var rv = moment().add(daysOffset, 'days').add(hoursOffset, 'hours').add(minutesOffset, 'minutes');
        return rv;
    }
    var isNextDayTime = hasNextDaySuffix(time);
    var actualTime = stripNextDaySuffix(time);
    var requestedDay = date ? moment.tz(date, timezone).format('MM-DD-YY') : moment().tz(timezone).format('MM-DD-YY');
    var requested = "".concat(requestedDay, " ").concat(actualTime);
    var rv1 = moment.tz(requested, 'MM-DD-YY hh:mmA', timezone).add(daysOffset, 'days').add(hoursOffset, 'hours').add(minutesOffset, 'minutes');
    // Add an extra day if it's a next-day time
    if (isNextDayTime) {
        rv1 = rv1.add(1, 'day');
    }
    return rv1;
};
export var formatDate = function(passedDate, format) {
    var date = _.isDate(passedDate) ? passedDate.toISOString() : passedDate;
    return moment(date).format(format);
};
/*
 * Hours that cross midnight (end time has the "(Next Day)" suffix) are keyed on the day
 * they start, so the forward-looking search in findNextOpenDay can't detect that we're
 * still within yesterday's window once the clock has rolled over to today. This checks
 * for that overnight-carryover case.
 */ var findPreviousDayOvernightWindow = function(param) {
    var standardHours = param.standardHours, specialHours = param.specialHours, timezone = param.timezone, now = param.now;
    var previousDay = now.clone().tz(timezone).startOf('day').subtract(1, 'day');
    var specialHoursDays = flow(map('hoursPerDay'), flattenDeep)(specialHours);
    var previousDayHours = standardHours[previousDay.format('dddd')];
    var specialHoursForPreviousDay = _.find(_.compact(specialHoursDays), function(param) {
        var date = param.date;
        return moment.tz(date, timezone).isSame(previousDay, 'day');
    });
    if (specialHoursForPreviousDay) {
        previousDayHours = specialHoursForPreviousDay.hours;
    }
    if (!(previousDayHours === null || previousDayHours === void 0 ? void 0 : previousDayHours.active) || !hasNextDaySuffix(previousDayHours.end)) {
        return null;
    }
    var start = previousDayHours.start === 'open' ? '12:00 AM' : previousDayHours.start;
    var actualEndTime = stripNextDaySuffix(previousDayHours.end);
    var openMoment = moment.tz("".concat(previousDay.format('MM-DD-YY'), " ").concat(start), 'MM-DD-YY hh:mmA', timezone);
    var closeMoment = moment.tz("".concat(previousDay.clone().add(1, 'day').format('MM-DD-YY'), " ").concat(actualEndTime), 'MM-DD-YY hh:mmA', timezone);
    if (now.isBefore(closeMoment)) {
        return {
            date: previousDay,
            openMoment: openMoment,
            closeMoment: closeMoment
        };
    }
    return null;
};
/*
 * Get hours, by type, for the next openn day, accounting for
 * special hours
 */ export var findNextOpenDay = function(param) {
    var _param_serviceType = param.serviceType, serviceType = _param_serviceType === void 0 ? 'pickup' : _param_serviceType, _param_standardHours = param.standardHours, standardHours = _param_standardHours === void 0 ? {} : _param_standardHours, _param_specialHours = param.specialHours, specialHours = _param_specialHours === void 0 ? {} : _param_specialHours, _param_timezone = param.timezone, timezone = _param_timezone === void 0 ? 'US/Pacific' : _param_timezone, now = param.now, _param_addedDays = param.addedDays, addedDays = _param_addedDays === void 0 ? 0 : _param_addedDays;
    if (addedDays > 7 || !standardHours) {
        return {};
    }
    if (addedDays === 0) {
        var previousDayWindow = findPreviousDayOvernightWindow({
            standardHours: standardHours,
            specialHours: specialHours,
            timezone: timezone,
            now: now
        });
        if (previousDayWindow) {
            return previousDayWindow;
        }
    }
    var specialHoursDays = flow(map('hoursPerDay'), flattenDeep)(specialHours);
    var nextDay = moment().tz(timezone).startOf('day').add(addedDays, 'days');
    var nextDayHours = standardHours[nextDay.format('dddd')];
    var specialHoursForNextDay = _.find(_.compact(specialHoursDays), function(param) {
        var date = param.date;
        return moment.tz(date, timezone).isSame(nextDay, 'day');
    });
    if (specialHoursForNextDay) {
        nextDayHours = specialHoursForNextDay.hours;
    }
    var start = nextDayHours.start === 'open' ? '12:00 AM' : nextDayHours.start;
    var end = nextDayHours.end === 'open' ? '12:00 AM' : nextDayHours.end;
    // Parse opening time (should not have Next Day suffix)
    var openMoment = moment.tz("".concat(nextDay.format('MM-DD-YY'), " ").concat(start), 'MM-DD-YY hh:mmA', timezone);
    var actualEndTime = stripNextDaySuffix(end);
    var isNextDayEnd = hasNextDaySuffix(end) || actualEndTime === '12:00 AM';
    // if open 24 hours or closing at midnight, close is 12:00 am the next day
    var closeMoment = moment.tz("".concat(nextDay.clone().add(nextDayHours.end === 'open' || isNextDayEnd ? 1 : 0, 'day').format('MM-DD-YY'), " ").concat(actualEndTime), 'MM-DD-YY hh:mmA', timezone);
    /* return hours for the first day that is either:
   *   a. today and the store has not yet closed
   *   b. after today
   */ if (nextDayHours.active && (now.isBefore(closeMoment) || !nextDay.isSame(now, 'day'))) {
        return {
            date: nextDay,
            openMoment: openMoment,
            closeMoment: closeMoment
        };
    }
    return findNextOpenDay({
        serviceType: serviceType,
        standardHours: standardHours,
        specialHours: specialHours,
        timezone: timezone,
        now: now,
        addedDays: addedDays + 1
    });
};
export var guessTimezone = function() {
    var guess = moment.tz.guess();
    if ([
        'America/New_York',
        'America/Detroit'
    ].includes(guess)) {
        return 'US/Eastern';
    }
    if (guess === 'America/Chicago') {
        return 'US/Central';
    }
    if ([
        'America/Denver',
        'America/Boise'
    ].includes(guess)) {
        return 'US/Mountain';
    }
    if ([
        'America/Los_Angeles',
        'America/Vancouver'
    ].includes(guess)) {
        return 'US/Pacific';
    }
    return guess;
};
// Complete ISO-8601 date with mandatory 4-digit year, 2-digit month (01-12), and 2-digit day (01-31).
// Optional time requires valid 2-digit hours (00-23), minutes (00-59), seconds (00-59),
// and an optional valid offset (Z or +-00:00 to +-14:59). Rejects impossible values such as
// 1964-04-20T99:99:99Z or 1964-04-20T00:00:00+99:99 (ECOMM-14395).
export var COMPLETE_ISO_DATE_REGEX = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])(?:[T ]([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.\d+)?(?:Z|[+-](?:0\d|1[0-4]):?[0-5]\d)?)?$/;
export var PADDED_US_DATE_REGEX = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;
export var UNPADDED_US_DATE_REGEX = /^(\d{1,2})[- /.](\d{1,2})[- /.](\d{4})$/;
/**
 * Parses a date-of-birth string across supported formats (ISO timestamps and US calendar formats),
 * enforcing complete-date and valid time/offset validation, and truncating to UTC midnight of the
 * calendar day to prevent offset-induced calendar day rolls (ECOMM-14395).
 *
 * Age floors are deliberately NOT enforced here: the 120-year minimum is owned by the
 * dispensary-timezone-aware validators (the apps/api birthday validator and the kiosk
 * birthday-utils), which compare against the dispensary-local calendar day. A UTC-day
 * floor here would wrongly reject a customer who is exactly 120 years old on the
 * dispensary-local day whenever the UTC day has already rolled over.
 *
 * @param {string | null | undefined} birthday
 * @param {{ allowUnpaddedUsDate?: boolean }} [options]
 * @returns {moment.Moment | null}
 */ export function parseBirthdayToUtcMidnight(birthday) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_allowUnpaddedUsDate = _ref.allowUnpaddedUsDate, allowUnpaddedUsDate = _ref_allowUnpaddedUsDate === void 0 ? true : _ref_allowUnpaddedUsDate;
    if (!birthday || typeof birthday !== 'string') {
        return null;
    }
    var trimmed = birthday.trim();
    if (!trimmed) {
        return null;
    }
    var isoMatch = COMPLETE_ISO_DATE_REGEX.exec(trimmed);
    if (isoMatch) {
        var _isoMatch = _sliced_to_array(isoMatch, 4), y = _isoMatch[1], m = _isoMatch[2], d = _isoMatch[3];
        var yearNum = Number(y);
        if (yearNum < 1900) {
            return null;
        }
        var parsed = moment.utc("".concat(y, "-").concat(m, "-").concat(d), 'YYYY-MM-DD', true);
        if (!parsed.isValid()) {
            return null;
        }
        return parsed;
    }
    var usRegex = allowUnpaddedUsDate ? UNPADDED_US_DATE_REGEX : PADDED_US_DATE_REGEX;
    var usMatch = usRegex.exec(trimmed);
    if (usMatch) {
        var parts = trimmed.split(/[- /.]/);
        var m1 = parts[0].padStart(2, '0');
        var d1 = parts[1].padStart(2, '0');
        var y1 = parts[2];
        var yearNum1 = Number(y1);
        if (yearNum1 < 1900) {
            return null;
        }
        var parsed1 = moment.utc("".concat(y1, "-").concat(m1, "-").concat(d1), 'YYYY-MM-DD', true);
        if (!parsed1.isValid()) {
            return null;
        }
        return parsed1;
    }
    return null;
}
